import { CreateBillDto } from "../../model/bill/dto/CreateBillDto";
import { DeleteBillDto } from "../../model/bill/dto/DeleteBillDto";
import { GetLatestBillsDto } from "../../model/bill/dto/GetLatestBillsDto";
import { UpdateBillDto } from "../../model/bill/dto/UpdateBillDto";
import { Bill } from "../../model/bill/types/Bill";
import { AtiraApi } from "../AxiosClient";

export class BillAxios {
  static getLatestBills(dto: GetLatestBillsDto) {
    return AtiraApi.post(`/bills/latest`, dto).then(({ data }) => data);
  }

  static updateBill(dto: UpdateBillDto) {
    return AtiraApi.patch(`/bills/edit/${dto._id}`, dto).then(
      ({ data }) => data
    );
  }

  static deleteBill(dto: DeleteBillDto) {
    return AtiraApi.delete(`/bills/delete/${dto.billId}`).then(
      ({ data }) => data
    );
  }

  static createBill(dto: CreateBillDto) {
    return AtiraApi.post<Bill>(`/bills/create`, dto).then(({ data }) => data);
  }

  static getBillNumber() {
    return AtiraApi.get<{ billNumber: number }>(`/bills/current-number`).then(
      ({ data }) => data
    );
  }
}
